import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Grid, Badge } from 'antd';
import IntlMessage from '../util-components/IntlMessage';
import Icon from '../util-components/Icon';
import navigationConfig from 'configs/NavigationConfig';
import { connect } from 'react-redux';
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from 'constants/ThemeConstant';
import utils from 'utils';
import { onMobileNavToggle } from 'redux/actions/Theme';

/**
 * ymploki-157: Add expired state for boats
 * ympshipyard: shipyard interface
 * loki-ribeiro-sc-241: Issues with side nav
 * olain-tarcina-sc-451: sales module
 * maco-magsael-sc-458: Calendars - develop calendar module
 * new-shipyard: redo shioyard
 * maco-magsael-sc-677: YMP Lite - Interface for lite equipment and jobs
 * maco-magsael-sc-689: Charter - create charter interface
 * maco-magsael-sc-691: Sales - Create TYS Sales module
 * maco-magsael-sc-913: Product - Product feature creation
 * maco-magsael-sc-986: Vessel Docs - Certification notifications / ISM - Changes to ISM
 * feb-sc-1117: Vessel docs - Certificate expiry notifications do not update until the page is refreshed.
 *
 * feb-sc-1118: Vessel Docs - Notifications missing in side navigation
 */

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = '';
  if (key) {
    const arr = key.split('-');
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
    user,
    dueTotal,
    expiredTotal,
    // modification start - 08.20.2022 - ymploki-157
    free,
    // modification end - 08.20.2022 - ymploki-157
    // modification start - 10.14.2022 - loki-ribeiro-sc-241
    navCollapsed,
    // modification end - 10.14.2022 - loki-ribeiro-sc-241
  } = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg');
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  // modification start - 08.20.2022 - ymploki-157
  const superadmin = user && user.superadmin;
  // modification end - 08.20.2022 - ymploki-157

  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? 'light' : 'dark'}
      mode="inline"
      style={{ height: '100%', borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? 'hide-group-title' : ''}
    >
      {/* modification start - 08.20.2022 - ymploki-157 */}
      {free !== 'EXPIRED' || superadmin
        ? navigationConfig.map((menu) =>
            menu.submenu.length > 0 ? (
              <Menu.ItemGroup
                key={menu.key}
                title={setLocale(localization, menu.title)}
              >
                {menu.submenu.map((subMenuFirst) =>
                  subMenuFirst.submenu.length > 0 ? (
                    <SubMenu
                      icon={
                        subMenuFirst.icon ? (
                          <Icon type={subMenuFirst?.icon} />
                        ) : null
                      }
                      key={subMenuFirst.key}
                      title={setLocale(localization, subMenuFirst.title)}
                    >
                      {subMenuFirst.submenu.map((subMenuSecond) => (
                        <Menu.Item key={subMenuSecond.key}>
                          {subMenuSecond.icon ? (
                            <Icon type={subMenuSecond?.icon} />
                          ) : null}
                          <span>
                            {setLocale(localization, subMenuSecond.title)}
                          </span>
                          <Link
                            onClick={() => closeMobileNav()}
                            to={subMenuSecond.path}
                          />
                        </Menu.Item>
                      ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item key={subMenuFirst.key}>
                      {subMenuFirst.icon ? (
                        <Icon type={subMenuFirst.icon} />
                      ) : null}
                      <span>{setLocale(localization, subMenuFirst.title)}</span>
                      <Link
                        onClick={() => closeMobileNav()}
                        to={subMenuFirst.path}
                      />
                    </Menu.Item>
                  )
                )}
              </Menu.ItemGroup>
            ) : (
              sidemenuSwitch(
                menu,
                localization,
                user,
                dueTotal,
                expiredTotal,
                closeMobileNav,
                // modification start - 10.14.2022 - loki-ribeiro-sc-241
                navCollapsed,
                isMobile
                // modification end - 10.14.2022 - loki-ribeiro-sc-241
              )
            )
          )
        : null}
      {/* modification end - 08.20.2022 - ymploki-157 */}
    </Menu>
  );
};

const TopNavContent = (props) => {
  //const { topNavColor, localization } = props;
  const {
    topNavColor,
    localization,
    user,
    dueTotal,
    expiredTotal,
    // modification start - 08.20.2022 - ymploki-157
    free,
    // modification end - 08.20.2022 - ymploki-157
  } = props;

  // modification start - 08.20.2022 - ymploki-157
  const superadmin = user && user.superadmin;
  // modification end - 08.20.2022 - ymploki-157

  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {/* modification start - 08.20.2022 - ymploki-157 */}
      {free !== 'EXPIRED' || superadmin
        ? navigationConfig.map((menu) =>
            menu.submenu.length > 0 ? (
              <SubMenu
                key={menu.key}
                popupClassName="top-nav-menu"
                title={
                  <span>
                    {menu.icon ? <Icon type={menu?.icon} /> : null}
                    <span>{setLocale(localization, menu.title)}</span>
                  </span>
                }
              >
                {menu.submenu.map((subMenuFirst) =>
                  subMenuFirst.submenu.length > 0 ? (
                    <SubMenu
                      key={subMenuFirst.key}
                      icon={
                        subMenuFirst.icon ? (
                          <Icon type={subMenuFirst?.icon} />
                        ) : null
                      }
                      title={setLocale(localization, subMenuFirst.title)}
                    >
                      {subMenuFirst.submenu.map((subMenuSecond) => (
                        <Menu.Item key={subMenuSecond.key}>
                          <span>
                            {setLocale(localization, subMenuSecond.title)}
                          </span>
                          <Link to={subMenuSecond.path} />
                        </Menu.Item>
                      ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item key={subMenuFirst.key}>
                      {subMenuFirst.icon ? (
                        <Icon type={subMenuFirst?.icon} />
                      ) : null}
                      <span>{setLocale(localization, subMenuFirst.title)}</span>
                      <Link to={subMenuFirst.path} />
                    </Menu.Item>
                  )
                )}
              </SubMenu>
            ) : (
              menuSwitch(menu, localization, user, dueTotal, expiredTotal)
            )
          )
        : null}
      {/* modification end - 08.20.2022 - ymploki-157 */}
    </Menu>
  );
};

const menuSwitch = (menu, localization, user, dueTotal, expiredTotal) => {
  const jobs = user && user.jobs;
  const logbook = user && user.logbook;
  const inventory = user && user.inventory;
  const employees = user && user.employees;
  const superadmin = user && user.superadmin;
  const watchkeeping = user && user.watchkeeping;
  const reports = user && user.reports;
  const supplier = user && user.supplier;
  const equipmentspage = user && user.equipmentspage;
  const documents = user && user.documents;
  const watchkeeper = user && user.watchkeeper;
  const ism = user && user.ism;
  const guests = user && user.guests;
  const hourstracker = user && user.hourstracker;
  const spareparts = user && user.spareparts;
  // modification start - 08.29.2022 - ympshipyard
  // modification start - 03.21.2024 - new-shipyard
  const shipyard = user && user.shipyard;
  // modification start - 03.21.2024 - new-shipyard
  // modification end - 08.29.2022 - ympshipyard
  // modification start - 12.16.2022 - loki-ribeiro-sc-277
  const accounting = user && user.accounting;
  // modification end - 12.16.2022 - loki-ribeiro-sc-277
  // Modification start - 03.07.2023 - olain-tarcina-sc-451
  const sales = user && user.sales;
  // Modification end - 12.07.2023 - olain-tarcina-sc-451
  // modification start - 08.04.2023 - maco-magsael-sc-458
  const calendar = user && user.calendar;
  // modification end - 08.04.2023 - maco-magsael-sc-458
  // modification start - 07.22.2023 - management-module
  const management = user && user.management;
  // modification end - 07.22.2023 - management-module
  // Modification start - 08.22.2024 - nmaco-magsael-sc-677
  const liteadmin = user && user.liteadmin;
  // Modification end - 08.22.2024 - nmaco-magsael-sc-677
  // Modification start - 09.22.2024 - maco-magsael-sc-689
  const charter = user && user.charter;
  // Modification end - 09.22.2024 - maco-magsael-sc-689
  // Modification start - 09.26.2024 - maco-magsael-sc-691
  const tyssales = user && user.tyssales;
  // Modification end - 09.26.2024 - maco-magsael-sc-691
  // modification start - 01.29.2026 - maco-magsael-sc-913
  const product = user && user.product;
  // modification end - 01.29.2026 - maco-magsael-sc-913
  const medicalinventory = user && user.medicalInventory;

  switch (menu.key) {
    case 'jobs':
      return jobs ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
          <Badge count={dueTotal}>
            <span style={{ marginLeft: '16px' }}> </span>
          </Badge>
        </Menu.Item>
      ) : null;
    // Modification start - 07.22.2023 - management-module
    case 'management':
      return management ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // modification end - 07.22.2023 - management-module
    case 'inventory':
      return inventory ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification start - 25.08.2026 - olain-tarcina-sc-1058
    case 'medicalinventory':
      return medicalinventory ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification end - 25.08.2026 - olain-tarcina-sc-1058
    case 'logbook':
      return logbook ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'equipmentspage':
      return equipmentspage ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'employees':
      return employees ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'superadmin':
      return superadmin ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'watchkeeping':
    case 'watchkeeper':
      return watchkeeping || watchkeeper ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'reports':
      return reports ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'supplier':
      return supplier ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'documents':
      return documents ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
          <Badge count={expiredTotal}>
            <span style={{ marginLeft: '16px' }}> </span>
          </Badge>
        </Menu.Item>
      ) : null;
    case 'ism':
      return ism ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'guests':
      return guests ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'hourstracker':
      return hourstracker ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'spareparts':
      return spareparts ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // modification start - 12.16.2022 - loki-ribeiro-sc-277
    case 'accounting':
      return accounting ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // modification end - 12.16.2022 - loki-ribeiro-sc-277
    // Modification start - 03.07.2023 - olain-tarcina-sc-451
    case 'sales':
      return sales ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification end - 12.07.2023 - olain-tarcina-sc-451
    // modification start - 08.29.2022 - ympshipyard
    // modification start - 03.21.2024 - new-shipyard
    case 'shipyard':
      return shipyard ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // modification end - 03.21.2024 - new-shipyard
    // modification end - 08.29.2022 - ympshipyard
    // modification start - 08.04.2023 - maco-magsael-sc-458
    case 'calendar':
      return calendar ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // modification end - 08.04.2023 - maco-magsael-sc-458
    // Modification start - 08.22.2024 - nmaco-magsael-sc-677
    case 'ymplite':
      return liteadmin ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification end - 08.22.2024 - nmaco-magsael-sc-677
    // Modification start - 09.22.2024 - maco-magsael-sc-689
    case 'charter':
      return charter ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification end - 09.22.2024 - maco-magsael-sc-689
    // Modification start - 09.26.2024 - maco-magsael-sc-691
    case 'tyssales':
      return tyssales ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification end - 09.26.2024 - maco-magsael-sc-691
    // modification start - 01.29.2026 - maco-magsael-sc-913
    case 'product':
      return product ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // modification end - 01.29.2026 - maco-magsael-sc-913
    default:
      return null;
  }
};

const sidemenuSwitch = (
  menu,
  localization,
  user,
  dueTotal,
  expiredTotal,
  closeMobileNav,
  // modification start - 10.14.2022 - loki-ribeiro-sc-241
  navCollapsed,
  isMobile
  // modification end - 10.14.2022 - loki-ribeiro-sc-241
) => {
  const jobs = user && user.jobs;
  const logbook = user && user.logbook;
  const inventory = user && user.inventory;
  const employees = user && user.employees;
  const superadmin = user && user.superadmin;
  const watchkeeping = user && user.watchkeeping;
  const reports = user && user.reports;
  const supplier = user && user.supplier;
  const equipmentspage = user && user.equipmentspage;
  const documents = user && user.documents;
  const watchkeeper = user && user.watchkeeper;
  const ism = user && user.ism;
  const guests = user && user.guests;
  const hourstracker = user && user.hourstracker;
  const spareparts = user && user.spareparts;
  // modification start - 08.29.2022 - ympshipyard
  // modification start - 03.21.2024 - new-shipyard
  const shipyard = user && user.shipyard;
  // modification end - 03.21.2024 - new-shipyard
  // modification end - 08.29.2022 - ympshipyard
  // modification start - 12.16.2022 - loki-ribeiro-sc-277
  const accounting = user && user.accounting;
  // modification end - 12.16.2022 - loki-ribeiro-sc-277
  // Modification start - 03.07.2023 - olain-tarcina-sc-451
  const sales = user && user.sales;
  // Modification end - 12.07.2023 - olain-tarcina-sc-451
  // modification start - 08.04.2023 - maco-magsael-sc-458
  const calendar = user && user.calendar;
  // modification end - 08.04.2023 - maco-magsael-sc-458
  // Modification start - 07.22.2023 - management-module
  const management = user && user.management;
  // Modification end - 07.22.2023 - management-module
  // Modification start - 08.22.2024 - nmaco-magsael-sc-677
  const liteadmin = user && user.liteadmin;
  // Modification end - 08.22.2024 - nmaco-magsael-sc-677
  // Modification start - 09.22.2024 - maco-magsael-sc-689
  const charter = user && user.charter;
  // Modification end - 09.22.2024 - maco-magsael-sc-689
  // Modification start - 09.26.2024 - maco-magsael-sc-691
  const tyssales = user && user.tyssales;
  // Modification end - 09.26.2024 - maco-magsael-sc-691
  // modification start - 01.29.2026 - maco-magsael-sc-913
  const product = user && user.product;
  // modification end - 01.29.2026 - maco-magsael-sc-913
  const medicalinventory = user && user.medicalInventory;

  switch (menu.key) {
    case 'jobs':
      return jobs ? (
        <Menu.Item key={menu.key}>
          {/* modification start - 10.14.2022 - loki-ribeiro-sc-241 */}
          <Badge count={dueTotal}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
          </Badge>
          {!navCollapsed || isMobile ? (
            <span>{setLocale(localization, menu?.title)}</span>
          ) : null}
          {/* modification end - 10.14.2022 - loki-ribeiro-sc-241 */}
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // Modification start - 07.22.2023 - management-module
    case 'management':
      return management ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // Modification end - 07.22.2023 - management-module
    case 'inventory':
      return inventory ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'medicalinventory':
      return medicalinventory ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    case 'logbook':
      return logbook ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'equipmentspage':
      return equipmentspage ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'employees':
      return employees ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'superadmin':
      return superadmin ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'watchkeeping':
      return watchkeeping ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'reports':
      return reports ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'supplier':
      return supplier ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'documents':
      return documents ? (
        <Menu.Item key={menu.key}>
          {/* modification start - 09.21.2026 - feb-sc-1118 */}
          <Badge count={expiredTotal}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
          </Badge>
          {!navCollapsed || isMobile ? (
            <span>{setLocale(localization, menu?.title)}</span>
          ) : null}
          {/* modification end - 09.21.2026 - feb-sc-1118 */}
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'watchkeeper':
      return watchkeeper ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'ism':
      return ism ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'guests':
      return guests ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'hourstracker':
      return hourstracker ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    case 'spareparts':
      return spareparts ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // modification start - 12.16.2022 - loki-ribeiro-sc-277
    case 'accounting':
      return accounting ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // modification start - 12.16.2022 - loki-ribeiro-sc-277
    // Modification start - 03.07.2023 - olain-tarcina-sc-451
    case 'sales':
      return sales ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // Modification end - 12.07.2023 - olain-tarcina-sc-451
    // modification start - 08.30.2022 - ympshipyard
    // modification start - 03.21.2024 - new-shipyard
    case 'shipyard':
      return shipyard ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // modification end - 03.21.2024 - new-shipyard
    // modification end - 08.30.2022 - ympshipyard
    // modification start - 08.04.2023 - maco-magsael-sc-458
    case 'calendar':
      return calendar ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // modification end - 08.04.2023 - maco-magsael-sc-458
    // Modification start - 08.22.2024 - nmaco-magsael-sc-677
    case 'ymplite':
      return liteadmin ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? <Icon type={menu?.icon} /> : null}
          <span>{setLocale(localization, menu?.title)}</span>
          {menu.path ? (
            <Link onClick={() => closeMobileNav()} to={menu.path} />
          ) : null}
        </Menu.Item>
      ) : null;
    // Modification end - 08.22.2024 - nmaco-magsael-sc-677
    // Modification start - 09.22.2024 - maco-magsael-sc-689
    case 'charter':
      return charter ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification end - 09.22.2024 - maco-magsael-sc-689
    // Modification start - 09.26.2024 - maco-magsael-sc-691
    case 'tyssales':
      return tyssales ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // Modification end - 09.26.2024 - maco-magsael-sc-691
    // modification start - 01.29.2026 - maco-magsael-sc-913
    case 'product':
      return product ? (
        <Menu.Item key={menu.key}>
          {menu.icon ? (
            <Icon type={menu?.icon} className="text-warning" />
          ) : null}
          <span className="text-primary">
            {setLocale(localization, menu?.title)}
          </span>
          {menu.path ? <Link to={menu.path} /> : null}
        </Menu.Item>
      ) : null;
    // modification end - 01.29.2026 - maco-magsael-sc-913
    default:
      return null;
  }
};

const MenuContent = (props) => {
  const {
    worklist: { joblist },
    // modification start - 09.21.2026 - feb-sc-1117
    doc: { expiredlist, allFiles },
    // modification end - 09.21.2026 - feb-sc-1117
    // modification start - 08.20.2022 - ymploki-157
    boat: { boatdetails },
    // modification end - 08.20.2022 - ymploki-157
  } = props;
  let dueTotal = 0;
  joblist &&
    joblist.length > 0 &&
    joblist.forEach((job) => (!job.status ? (dueTotal += 1) : null));
  // modification start - 09.21.2026 - feb-sc-1117
  const expiredTotal = allFiles?.length
    ? allFiles.filter((f) => f.expDate && new Date(f.expDate) <= new Date()).length
    : expiredlist?.length || 0;
  // modification end - 09.21.2026 - feb-sc-1117

  // modification start - 08.20.2022 - ymploki-157
  const free = boatdetails && boatdetails.free;
  // modification end - 08.20.2022 - ymploki-157
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent
      {...props}
      dueTotal={dueTotal}
      expiredTotal={expiredTotal}
      free={free}
    />
  ) : (
    <TopNavContent
      {...props}
      dueTotal={dueTotal}
      expiredTotal={expiredTotal}
      free={free}
    />
  );
};

const mapStateToProps = (state) => ({
  sideNavTheme: state.theme.sideNavTheme,
  worklist: state.worklist,
  doc: state.doc,
  topNavColor: state.theme.topNavColor,
  user: state.auth.user,
  // modification start - 08.20.2022 - ymploki-157
  boat: state.boat,
  // modification end - 08.20.2022 - ymploki-157
  // modification start - 10.14.2022 - loki-ribeiro-sc-241
  navCollapsed: state.theme.navCollapsed,
  // modification end - 10.14.2022 - loki-ribeiro-sc-241
});

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
